import React from "react";
import { Box, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BRAND_ORANGE } from "../../constants/constants";

interface AppDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  width?: number | string;
  children: React.ReactNode;
  footerActions?: React.ReactNode;
}

const AppDrawer: React.FC<AppDrawerProps> = ({
  open,
  onClose,
  title,
  width = 480,
  children,
  footerActions,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "85vw", md: width ?? 480 },
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#1a1a1a",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 1.5,
              borderBottom: "1px solid #333",
              borderLeft: `3px solid ${BRAND_ORANGE}`,
            }}
          >
            <Typography sx={{ color: "#fff", fontSize: "16px", fontWeight: 500 }}>
              {title}
            </Typography>
            <IconButton onClick={onClose} aria-label="Close drawer" sx={{ color: "#fff" }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            padding: "16px",
            minHeight: 0,
          }}
        >
          {children}
        </Box>

        {footerActions && (
          <Box
            sx={{
              flexShrink: 0,
              borderTop: "1px solid #333",
              padding: "12px 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {footerActions}
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default AppDrawer;
